export default "<div style=\"width: 30vw;\">\n    <canvas #donutChart height=\"300\"></canvas>\n  </div>\n  ";